import { render, staticRenderFns } from "./AddProxyDialog.vue?vue&type=template&id=37add4fd&"
import script from "./AddProxyDialog.vue?vue&type=script&lang=js&"
export * from "./AddProxyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports